import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { TwoFactorDialogComponent } from 'src/app/dialogs/profile/two-factor-dialog/two-factor-dialog.component';
import { UsersService } from 'src/app/services/users/users.service';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
import { PayeeIconButtonComponent } from '../../../shared/payee-buttons/payee-icon-button/payee-icon-button.component';
import { PayeeIconComponent } from '../../../shared/payee-icon/payee-icon.component';
import { PayeeButtonComponent } from '../../../shared/payee-buttons/payee-button/payee-button.component';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [
    PayeeIconButtonComponent,
    PayeeIconComponent,
    PayeeButtonComponent,
    MatMenuTrigger,
    MatMenu,
    MatMenuItem,
    TranslateModule,
  ],
})
export class HeaderComponent implements OnInit, OnDestroy {
  private usersService = inject(UsersService);
  private authService = inject(AuthService);
  private dialog = inject(MatDialog);

  private readonly destroy = new Subject<void>();
  userName?: string;
  has2FA = false;

  ngOnInit(): void {
    this.usersService.userSubject
      .pipe(takeUntil(this.destroy))
      .subscribe((user) => {
        this.userName = user?.name;
        this.has2FA = user?.has_2fa ?? false;
      });
  }

  ngOnDestroy(): void {
    this.destroy.next();
    this.destroy.complete();
  }

  manageMFA(): void {
    this.dialog.open(TwoFactorDialogComponent, {
      autoFocus: false,
      data: { has2FA: this.has2FA },
      position: {
        top: '50px',
      },
    });
  }

  async logout(): Promise<void> {
    await this.authService.logout();
  }
}
